
import React, { createContext, useContext, useState } from 'react';

const NavigationContext = createContext();

export const NavigationProvider = ({ children }) => {
  const [customNavConfig, setCustomNavConfig] = useState(null);
  const [customNavHandler, setCustomNavHandler] = useState(null);

  const updateNavigation = (config, handler) => {
    console.log('[NavigationContext] Updating navigation:', config);
    setCustomNavConfig(config);
    setCustomNavHandler(() => handler);
  };

  const resetNavigation = () => {
    console.log('[NavigationContext] Resetting navigation');
    setCustomNavConfig(null);
    setCustomNavHandler(null);
  };

  return (
    <NavigationContext.Provider value={{ 
      customNavConfig, 
      customNavHandler, 
      updateNavigation, 
      resetNavigation 
    }}>
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigation = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    // Return dummy functions if not in provider (for backwards compatibility)
    return {
      customNavConfig: null,
      customNavHandler: null,
      updateNavigation: () => {},
      resetNavigation: () => {}
    };
  }
  return context;
};